/**
 * Flow resolver collection context.
 *
 * Provides a mechanism for components to register {@link FlowResolverEntry}
 * resolvers that steer the turn-flow engine. The transport and the
 * loop-continuation site read the registered resolvers to evaluate
 * {@link resolveFlow} at the `sendMessages` boundary.
 */

import { createContext } from 'react';

import type { FlowResolverEntry } from '#plugin-chat/lib/flow/types.ts';

/** Context interface for flow resolver registration. */
export interface FlowContextType {
  /** Register a resolver; returns a cleanup that removes it on unmount. */
  registerFlowResolver: (entry: FlowResolverEntry) => () => void;
  /** All registered resolvers, sorted ascending by priority. */
  getFlowResolvers: () => FlowResolverEntry[];
}

/** Default no-op context for when used outside FlowProvider. */
export const FlowContext = createContext<FlowContextType>({
  registerFlowResolver: () => () => {
    // No-op cleanup when used outside FlowProvider
  },
  getFlowResolvers: () => [],
});
